import React, { useEffect, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import { encryptAndStoreLoc, requestHandler } from '../helper/index';
import { adminLogin } from '../controller';
import { useNavigate } from 'react-router-dom';
import * as CustomToast from '../components/CustomToastMessage';


function Login() {

    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [userData, setUserData] = useState({
        email: '',
        password: '',
    });

    const navigate = useNavigate();

    const togglePasswordVisibility = () => {
        setIsPasswordVisible(!isPasswordVisible);
    };

    const emailRef = useRef(null);

    useEffect(() => {
        if (emailRef.current) {
            emailRef.current.focus();
        }
    }, []);

    const HandleOnchange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {

        const data = {
            email: userData.email.trim(),
            password: userData.password
        }

        await requestHandler(
            async () => await adminLogin(data),
            null,
            (res) => {
                console.log(res.data.token);
                CustomToast.success(res.message);
                encryptAndStoreLoc("token", { token: res.data.token });
                navigate("/dashboard")
                setUserData({
                    email: '',
                    password: '',
                })
            },
            () => { }
        );
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleSubmit();
        }
    };

    return (
        <>
            <section className='auth_bg d-flex justify-content-center align-items-center'>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-8 col-lg-6 col-xl-4">
                            <div className="card">
                                <div className="card-body">
                                    <img className='logo' src="../images/logo/logo.png" alt="" />
                                    <h4>Login</h4>
                                    <p>Enter email and password to continue</p>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter email"
                                            id="email"
                                            name="email"
                                            onChange={HandleOnchange}
                                            ref={emailRef}
                                            value={userData.email}
                                            onKeyDown={handleKeyDown}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3 position-relative">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control
                                            type={isPasswordVisible ? "text" : "password"}
                                            placeholder="Enter Password"
                                            id="password"
                                            name="password"
                                            onChange={HandleOnchange}
                                            value={userData.password}
                                            onKeyDown={handleKeyDown}
                                        />
                                        <span
                                            className="password-icon"
                                            onClick={togglePasswordVisibility}
                                        >
                                            <img src={`/images/png/${isPasswordVisible ? "eye-show.png" : "eye-hide.png"}`} alt="" />
                                        </span>
                                    </Form.Group>
                                    <button
                                        type='button'
                                        onClick={handleSubmit}
                                        className='btn-primary w-100'
                                    >
                                        Login
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Login